import { useEffect, useState } from "react";
import RichTextEditor from "../../../../RichTextEditor/RichTextEditor";
import { useDebouncedCallback } from '../../../../../helpers/debounce'

type Props = {
  workareaOrGroupId?: number | string
  notes?: string
  onChange: (value: string) => void
  forceUpdateCounter: number
}

const NotesEditor = ({ workareaOrGroupId, notes, onChange, forceUpdateCounter }: Props) => {
  const [value, setValue] = useState('')

  const debouncedOnChange = useDebouncedCallback((value) => onChange(value), 2500, [onChange, workareaOrGroupId], {flushBeforeCancel: true})

  useEffect(() => {
    setValue(notes ?? '')
  }, [workareaOrGroupId, forceUpdateCounter])

  const handleChange = (newValue: string) => {
    setValue(newValue)
    debouncedOnChange(newValue)
  }

  return <RichTextEditor value={value} onChange={handleChange} />
}

export default NotesEditor
